<template>
  <v-row
    class="w-100 pa-2"
  >
    <EMChart
      v-if="chartHasData"
      :options='options'
      ref='emChart'
    ></EMChart>
    <EMOverlay
    v-else
    :showOverlay="!chartHasData"
    :text="$t('no_values')"
    icon="mdi-database-off-outline"
  />
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import EMChart from './EMChart.vue';
import EMOverlay from '../../../Overlay/EMOverlay.vue';

export default {
  name: 'EMPlotChartCreator',
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  components: {
    EMChart,
    EMOverlay,
  },
  data() {
    return {
      updatePointInterval: null,
      updatePointTime: 6000,
    };
  },
  computed: {
    ...mapGetters(['getTagsList', 'getTagDataByName']),
    getLatestTagValue() {
      return this.getTagDataByName(this.tag.name);
    },
    options() {
      const tag = this.getTagDataByName(this.tag.name);
      if (tag) {
        const chartOptionsObj = tag.data;
        return chartOptionsObj;
      }
      return {};
    },
    chartHasData() {
      return this.getLatestTagValue !== null && this.getLatestTagValue !== undefined;
    },
  },
};
</script>

<style>
:root {
  --primary-color: rgba(100, 30, 140, 1);
  --primary-color-light: rgba(77, 33, 122, 1);
  --text-color: rgba(29, 29, 29, 1);

  --secondary-color: rgba(100, 30, 140, 1);
  --accent-color: rgba(0, 155, 85, 1);
  --outline-color: rgba(0, 0, 0, 0.2);

  --background-color: rgba(244, 247, 250, 1);
  --background-darker-color: rgba(219, 228, 235, 1);

  --status-critical-color: rgba(181, 55, 55, 1);
  --status-warning-color: rgba(193, 179, 86, 1);
  --status-ok-color: rgba(93, 169, 96, 1);
  --status-overdue-color: rgba(77, 139, 184, 1);
  --status-inactive-color: rgba(176, 176, 176, 1);

  --selection-color: color-mix(in srgb, var(--primary-color) 20%, transparent);

  --primary-color-filter: invert(18%) sepia(47%) saturate(4618%)
  hue-rotate(269deg) brightness(77%) contrast(97%);

  /* Materials */
  --material-oil-color: rgba(138, 93, 59, 1);
  --material-gas-color: rgba(253, 216, 69, 1);
  --material-water-color: rgba(138, 199, 155, 1);

  /* Area */
  --area-unaccepted-color: rgba(252, 159, 159, 0.48);
  --area-accepted-color: rgba(61, 121, 143, 0.48);
  --area-critical-color: rgba(200, 0, 0, 0.2);
  --area-warning-color: rgba(200, 200, 0, 0.3);

  /* Highcharts colors */
  --highcharts-color-0: rgba(100, 30, 140, 0.69);
  --highcharts-color-1: rgba(0, 155, 85, 0.69);
  --highcharts-color-2: rgba(198, 174, 0, 0.69);
  --highcharts-color-3: rgba(0, 87, 198, 0.69);
  --highcharts-color-4: rgba(125, 103, 102, 0.69);
  --highcharts-color-5: rgba(215, 228, 238, 0.69);
  --highcharts-color-6: rgba(246, 230, 0, 0.69);
  --highcharts-color-7: rgba(0, 153, 153, 0.69);
  --highcharts-color-8: rgba(0, 132, 225, 0.69);
  --highcharts-color-9: rgba(175, 158, 156, 0.69);
  --highcharts-color-10: rgba(138, 0, 229, 0.69);
}
</style>
